module.exports = __webpack_public_path__ + "img/register-gif.9e4c67f0.gif";